import React from 'react';
import classNames from 'classnames';
import './Notice.scss';

type AdditionalNoticeProps = {
  additionalNoticeCount: number;
};

/**
 * A special notice component that is appears at the end of the notices to
 * notify of additional notices that are currently hidden
 */
const AdditionalNotice: React.FC<AdditionalNoticeProps> = ({ additionalNoticeCount }) => {
  const cx = classNames('Notice', 'Notice-additional');

  return (
    <div className={cx}>
      <div className="Notice-Content">
        <span className="Notice-Message">(... {additionalNoticeCount} more)</span>
      </div>
    </div>
  );
};

export { AdditionalNotice };
export default AdditionalNotice;
